<template>
  <div>
    <div v-if='backgroundInfo.type === "transform"'>
      <toggle-switch v-model='enableAnimation' label='Animate' />
      <div v-show='false' class="flex flex-row w-full px-3 my-2">
        <input class="rounded-lg overflow-hidden appearance-none bg-gray-400" type="range" min="0.1" max="2" step="0.05" v-model.number="backgroundInfo.component.sizex" @input='lol' />

        <p class="grow text-gray-200 font-semibold text-sm text-center">Size</p>

        <input class="rounded-lg overflow-hidden appearance-none bg-gray-400" type="range" min="0.1" max="2" step="0.05" v-model.number="backgroundInfo.component.sizey" @input='lol' />

      </div>
      <div v-show='false' class="flex flex-row w-full px-3 my-2">
        <input class="rounded-lg overflow-hidden appearance-none bg-gray-400" type="range" min="-0.5" max="0.5" step="0.05" v-model.number="backgroundInfo.component.offsetx" @input='lol' />

        <p class="grow text-gray-200 font-semibold text-sm text-center">Position</p>

        <input class="vertical-slider rounded-lg overflow-hidden appearance-none bg-gray-400"
                type="range"
                min="-0.5"
                max="0.5"
                step="0.05"
                v-model.number="backgroundInfo.component.offsety"
                @input='lol' />

      </div>

      <div v-if='automove' class="flex flex-row w-full px-3 my-2">
        <input class="rounded-lg overflow-hidden appearance-none bg-gray-400"
               type="range"
               min="-3"
               max="3"
               step="0.1"
               v-model.number="automove.dx"
               @input='lol'
               />

        <p class="grow text-gray-200 font-semibold text-sm text-center">
          Speed
        </p>

        <input class="rounded-lg overflow-hidden appearance-none bg-gray-400"
               type="range"
               min="-3"
               max="3"
               step="0.1"
               v-model.number="automove.dy"
               @input='lol'
               />
      </div>
    </div>
  </div>
</template>
<script>
import Treeutil from '@edit/tree/treeutil.js';
//import Numberer from '@ui/atoms/Numberer.vue';
import Animator from '@edit/tree/animator.js';
export default {
  props:{
    backgroundInfo:{
      type: Object,
      required:true
    },
    partutil:{
      type: Object,
      required:true
    },
    renderTools:{
      type:Object,
      required:true
    }
  },
  components:{
    //Numberer
  },
  mounted() {
    if (this.backgroundInfo.type === 'transform') {
      this.automove = this.findAutomove();
    }
    if (this.backgroundInfo.type === 'transform') {
      let automove = this.animator.getAfterEnterAutomove(this.backgroundInfo.transform);
      if (automove) {
        this.enableAnimation = true;
      }
    }
  },
  data() {
    const gamedata = this.partutil.gamedata.gamedata;
    const animator = new Animator(this.partutil.gamedata, this.partutil, gamedata.game.timelimit || 3, 15);
    return {
      animator,
      automove:{dx:0,dy:0},
      enableAnimation: false
    }
  },
  methods: {
    lol() {
      this.$emit('restart');
    },
    findAutomove() {
      console.log('find automove');
      if (this.enableAnimation) {
        return this.animator.getAfterEnterAutomove(this.backgroundInfo.transform, true);
      } else {
        return undefined;
      }
    },
  },
  watch:{
    enableAnimation(nv) {
      if (nv) {
        this.automove = this.findAutomove();
      } else {
        if (this.automove) {
          const treeutil = new Treeutil(this.partutil.from);
          treeutil.removeComponent(this.automove);
          this.automove = undefined;
        }
      }
    },
    backgroundInfo() {
      if (this.backgroundInfo.type === 'transform') {
        this.automove = this.findAutomove();
        //this.$emit('restart');
      }
    },
    'backgroundInfo.type'() {
      if (this.backgroundInfo.type === 'transform') {
        this.automove = this.findAutomove();
        this.$emit('restart');
      }
    },
    'automove.id'() {
      this.$emit('restart');
    }
  }

}
</script>
